import {
  lxMC, lxMV, lxOrder, lxPV, lxSetTag,
} from '../../lx/index.h5';

const Statistics = {
  pv(cid: string, data?: Object, ss?: string, key?: string) {
    // const webCid = CidMap[cid];
    // lxPV(webCid, data);
    lxPV(cid, data);
  },
  pd() {
    // 页面消失埋点
  },
  pvm(cid: string, data?: Object, ss?: string, key?: string) {
    // const webCid = CidMap[cid];
    // lxPV(webCid, data);
    lxPV(cid, data);
  },
  view(cid: string, bid: string, data?: Object, key?: string) {
    // const webCid = CidMap[cid];
    // const webBid = BidMap[bid];
    // lxMV(webBid, webCid, data);
    lxMV(bid, cid, data);
  },
  order(cid: string, bid: string, data?: Object, category?: string) {
    // Statistics.order(CID, bid, val, 'sailor_c');
    lxOrder(cid, bid, data, category);
  },
  click(cid: string, bid: string, data?: Object, key?: string) {
    // console.log('click', bid, data, key);
    // const webCid = CidMap[cid];
    // const webBid = BidMap[bid];
    // lxMC(webBid, webCid, data);
    lxMC(bid, cid, data);
  },
  setTag(category, data, ...args) {
    // https://km.sankuai.com/collabpage/2704622240#b-be05ae1a84d6471da67a005fb24c6606
    // console.log('setTag', category, data, args);
    lxSetTag(category, data);
  },
};

export default Statistics;
